import http from "./http";
const root = "/public/sms-consent";
const unwrap = (r) => r.data?.data ?? r.data;
export const getConsentGym = async (slug) => unwrap(await http.get(`${root}/gyms/${encodeURIComponent(slug)}`));
export const createConsentRequest = async (slug, body) => unwrap(await http.post(`${root}/gyms/${encodeURIComponent(slug)}/requests`, body));
export const consentAction = async (id, action, body) => unwrap(await http.post(`${root}/requests/${encodeURIComponent(id)}/${action}`, body));

export const submitContactPreferences = async (slug, body) => unwrap(await http.post(`${root}/gyms/${encodeURIComponent(slug)}/contact`, body));

export const requestEmailSubscription = async (slug, body) => unwrap(await http.post(`${root}/gyms/${encodeURIComponent(slug)}/email-subscription`, body));
export const confirmEmailSubscription = async (slug, body) => unwrap(await http.post(`${root}/gyms/${encodeURIComponent(slug)}/email-subscription/confirm`, body));
